import { parseDecimalInput } from '../../shared/numeric/localeNumeric';
import type { InventoryFlowResult } from './inventoryOperations.types';
import type { AdjustStockForm } from './inventoryOperations.types';
import { stockQuantityAllowsFraction } from './inventoryUtils';

export function parseAdjustStockForm(
  ctx: { canEdit: boolean; canAdjust?: boolean },
  form: AdjustStockForm
): InventoryFlowResult<{ stockId: string; delta: number; reason: AdjustStockForm['adjustReason'] }> {
  if (!ctx.canAdjust) {
    return {
      kind: 'blocked',
      notice: {
        tone: 'info',
        title: 'Solo lectura',
        message: 'Podés ver el stock, no ajustarlo.',
      },
    };
  }
  if (!form.stockRow) {
    return { kind: 'blocked', notice: { tone: 'error', title: 'Error', message: 'Elegí un producto.' } };
  }
  const allowsFraction = stockQuantityAllowsFraction(form.stockRow.unitOfMeasure);
  const delta = parseDecimalInput(form.adjustDelta, {
    integerOnly: !allowsFraction,
    allowNegative: true,
  });
  if (delta === null || delta === 0) {
    return {
      kind: 'blocked',
      notice: {
        tone: 'error',
        title: 'Cantidad inválida',
        message: allowsFraction
          ? 'Ingresá un número distinto de cero (ej. -0,5 o 2).'
          : 'Ingresá un entero distinto de cero (ej. -3 o 5).',
      },
    };
  }
  // #1497: la baja por vencimiento es inherentemente negativa.
  if (form.adjustReason === 'expiry_writeoff' && delta > 0) {
    return {
      kind: 'blocked',
      notice: {
        tone: 'error',
        title: 'Cantidad inválida',
        message: 'La baja por vencimiento descuenta unidades: ingresá una cantidad negativa.',
      },
    };
  }
  return {
    kind: 'done',
    refresh: { stocks: true, branchActivity: true, dashboard: true },
    data: { stockId: form.stockRow.id, delta, reason: form.adjustReason },
  };
}
